/**
 * Updated Variant Image Filter for Shopify PDP
 * This script is designed to work with the Dawn theme's gang connection system
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait a moment for the theme's JS to initialize
  // console.log("xxxxxxxxxxxxxxxxxxxxxxxx=>")
  setTimeout(initVariantImageFilter, 500);
  
  function initVariantImageFilter() {
    // console.log("Initializing variant image filter");
    
    // Find variant selectors (both dropdown and radio buttons)
    const variantSelectors = document.querySelectorAll('.product-form__input select, .product-form__input input[type="radio"]');
    
    if (variantSelectors.length === 0) {
      console.log("No variant selectors found");
      return;
    }
    
    // Get all product media items and thumbnails
    const mediaItems = document.querySelectorAll('.product__media-item');
    const thumbnailItems = document.querySelectorAll('.thumbnail-list__item, .product__thumbnail');
    
    console.log(`Found ${mediaItems.length} media items and ${thumbnailItems.length} thumbnail items`);
    
    // Create a function to check if an element has the gang attributes by checking the element's class list
    function hasGangAttributes(element) {
      // Print the element's class list to debug
      // console.log("Element classes:", element.className);
      return element.className.includes('gang__');
    }
    
    // Debug: log the first few media items' attributes
    mediaItems.forEach((item, index) => {
      if (index < 3) {
        console.log(`Media item ${index}:`, {
          gangAttributes: hasGangAttributes(item),
          classes: item.className,
          dataAttributes: {
            gangOption: item.getAttribute('data-gang-option'),
            gangConnect: item.getAttribute('data-gang-connect')
          }
        });
      }
    });
    
    // Add event listeners to the variant selectors
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        console.log("Variant changed:", selector.value);
        handleVariantChange(selector.closest('section'));
      });
    });
    
    // Initial filtering on page load
    handleVariantChange();
    
    function handleVariantChange(element = document) {
      // Get the currently selected variant options
      const selectedVariant = {};
      
      // Process dropdown selectors
      element.querySelectorAll('.product-form__input select').forEach(select => {
        const optionName = select.getAttribute('name')?.split('_')[0] || select.closest('.product-form__input')?.querySelector('label')?.textContent;
        if (optionName) {
          const cleanName = optionName.trim().toLowerCase().replace(/\s+/g, '_');
          selectedVariant[cleanName] = select.value.toLowerCase().replace(/\s+/g, '_');
        }
      });
      
      // Process radio button selectors
      element.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(radio => {
        const optionName = radio.getAttribute('name')?.split('_')[0] || radio.closest('.product-form__input')?.querySelector('legend')?.textContent;
        if (optionName) {
          const cleanName = optionName.trim().toLowerCase().replace(/\s+/g, '_');
          selectedVariant[cleanName] = radio.value.toLowerCase().replace(/\s+/g, '_');
        }
      });
      
      console.log("Selected variant:", selectedVariant);
      
      // Handle media filtering
      filterByVariant(element.querySelectorAll('.product .product__media img'), selectedVariant)
      filterByVariant(element.querySelectorAll('.product__media-item'), selectedVariant);
      filterByVariant(element.querySelectorAll('.thumbnail-list__item, .product__thumbnail'), selectedVariant);
    }
    
    function filterByVariant(items, selectedVariant) {
      // Check if we have variant information to filter by
      if (Object.keys(selectedVariant).length === 0) {
        console.log("No variant information available");
        return;
      }
      
      // Track if we've shown any items
      let anyShown = false;
      
      // Process each media item
      items.forEach(item => {
        // First try the data attributes
        let gangOption = item.getAttribute('data-gang-option');
        let gangConnect = item.getAttribute('data-gang-connect');
        
        // If data attributes aren't available, try to get from classes
        if (!gangOption || !gangConnect) {
          // Check for gang__active class or other clues
          const isGangItem = item.className.includes('gang__');
          
          if (isGangItem) {
            // Try to parse gang info from classes
            const classNames = item.className.split(' ');
            classNames.forEach(className => {
              if (className.startsWith('data-gang-')) {
                const parts = className.replace('data-gang-', '').split('-');
                if (parts.length >= 2) {
                  gangOption = parts[0];
                  gangConnect = parts.slice(1).join('_');
                }
              }
            });
          }
        }
        
        // For debugging
        if (!gangOption || !gangConnect) {
          //console.log("Item has no gang information:", item);
        }
        
        // Determine if this item should be visible
        let shouldShow = true;
        
        if (gangOption && gangConnect) {
          // Check if this gang option is in our selected variant
          const variantValue = selectedVariant[gangOption];
          const expectedConnect = `${gangOption}_${variantValue}`;
          
          shouldShow = (gangConnect === expectedConnect);
          console.log(`Checking ${gangConnect} against ${expectedConnect}: ${shouldShow}`);
        }
        
        // Apply visibility
        if (shouldShow) {
          item.style.display = '';
          anyShown = true;
          
          // If this is a media item and the first visible one, make it active
          if (item.classList.contains('product__media-item') && 
              !document.querySelector('.product__media-item.is-active:not([style*="display: none"])')) {
            document.querySelectorAll('.product__media-item.is-active').forEach(active => {
              active.classList.remove('is-active');
            });
            item.classList.add('is-active');
          }
        } else {
          item.style.display = 'none';
        }
      });
      
      // If no items are visible, show all of them
      if (!anyShown) {
        console.log("No items match the variant - showing all");
        items.forEach(item => {
          item.style.display = '';
        });
      }
    }
  }
});

// Alternative approach: Use alt text containing variant info
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initAltTextVariantFilter, 700);
  
  function initAltTextVariantFilter() {
    console.log("Initializing alt text variant filter");
    
    // Find variant selectors
    const variantSelectors = document.querySelectorAll('.product-form__input select, .product-form__input input[type="radio"]');
    
    if (variantSelectors.length === 0) {
      console.log("No variant selectors found for alt text filter");
      return;
    }
    
    // Get all product images
    const productImages = document.querySelectorAll('.product .product__media img');
    const thumbnailImages = document.querySelectorAll('.thumbnail-list__item img, .product__thumbnail img');
    const modelImages = document.querySelectorAll('.product .product-media-modal__content .media img')
    
    console.log(`Found ${productImages.length} product images and ${thumbnailImages.length} thumbnail images`);
    
    // Add event listeners to the variant selectors
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        console.log("Variant changed for alt text filter:", selector.value);
        filterImagesByAltText(selector.closest('section'));
      });
    });
    
    // Initial filtering on page load
    filterImagesByAltText();
    // setTimeout(filterImagesByAltText, 700);
    
    function filterImagesByAltText(element=document) {
      // Get the currently selected variant options
      const selectedVariant = {};
      const variantMarkers = [];
      const closestSection = {};
      
      // Process dropdown selectors
      if(element){
         element.querySelectorAll('.product-form__input select').forEach(select => {
        const optionName = select.getAttribute('name')?.split('_')[0] || select.closest('.product-form__input')?.querySelector('label')?.textContent;
        if (optionName) {
          const cleanName = optionName.trim().toLowerCase().replace(/\s+/g, '_');
          selectedVariant[cleanName] = select.value.toLowerCase().replace(/\s+/g, '_');
          //variantMarkers.push(`#${cleanName}_${selectedVariant[cleanName]}`);
        }
      });
      
      // Process radio button selectors
      element.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(radio => {
        const optionName = radio.getAttribute('name')?.split('_')[0] || radio.closest('.product-form__input')?.querySelector('legend')?.textContent;
        if (optionName) {
          const cleanName = optionName.trim().toLowerCase().replace(/\s+/g, '_');
          selectedVariant[cleanName] = radio.value.toLowerCase().replace(/\s+/g, '_');
           // if(!variantMarkers.includes(`#${cleanName}_${selectedVariant[cleanName]}`)) {
              variantMarkers.push(`#${cleanName}_${selectedVariant[cleanName]}`);
              const _closestSection = radio.closest('section');
              if(_closestSection){
                closestSection[`#${cleanName}_${selectedVariant[cleanName]}-${_closestSection.id}`] = _closestSection;
              }
           // }
        }
      });
      }
      
      console.log("Selected variant for alt text filter:", selectedVariant);
      
      // Create variant markers to search for in alt text
      for (const [option, value] of Object.entries(selectedVariant)) {
        variantMarkers.push(`#${option}_${value}`);
      }
      
      console.log("Looking for these markers in alt text:", variantMarkers);
      
      // Filter main product images
        console.log("Closest Section", (Object.entries(closestSection).length>0));
      if(Object.entries(closestSection).length>0){
        console.log("Closest Section1", closestSection[variantMarkers[0]]);

        for (const [key, element1] of Object.entries(closestSection)) {
          const selector = key.split('-')[0];
          console.log(selector)
          if (/colour/i.test(selector)) { 
            filterImageCollection(element1.querySelectorAll('.product__media img'), [selector]);
            filterImageCollection(element1.querySelectorAll('.thumbnail-list__item img, .product__thumbnail img'), [selector]);
            filterImageCollection(element1.querySelectorAll('.product-media-modal__content .media img'), [selector]);
          }
        }
        // variantMarkers.forEach(selector => {
        //   const element1 = closestSection[selector] || element;
        // });
      }else{
        filterImageCollection(element.querySelectorAll('.product__media img'), variantMarkers);
        filterImageCollection(element.querySelectorAll('.thumbnail-list__item img, .product__thumbnail img'), variantMarkers);
        filterImageCollection(element.querySelectorAll('.product-media-modal__content .media img'), variantMarkers);        
      }
    }
    
    function filterImageCollection(images, variantMarkers) {
      // Check if we have variant information to filter by
      // console.log(images)
      if (variantMarkers.length === 0) {
        console.log("No variant markers available");
        return;
      }
      
      // Track if we've shown any images
      let anyShown = false;
      let shownImages = 0;
      
      // Process each image
      images.forEach(img => {
        // Get the alt text and check for variant markers
        let altText = img.getAttribute('alt') || '';
        altText = altText.replace("color_", "colour_");

        console.log(altText, "xxxxxxxxxxxxxxx");
        
        // Check if this image is variant-specific (has a # marker)
        const isVariantSpecific = altText.includes('#');
        
        // If not variant specific, always show it
        if (!isVariantSpecific) {
          showMediaItem(img);
          anyShown = true;
          shownImages++;
          return;
        }
        
        // Check if this image matches any of our variant markers
        let matchesVariant = false;
        for (const marker of variantMarkers) {
          if (altText.toLowerCase().includes(marker)) {
          // console.log(marker)
            matchesVariant = true;
            break;
          }else{
            matchesVariant = false;
          }
        }
        
        // Show or hide based on match
        if (matchesVariant) {
          showMediaItem(img);
          anyShown = true;
          shownImages++;
        } else {
          hideMediaItem(img);
        }
      });
      
      console.log(`Showing ${shownImages} of ${images.length} images`);
      
      // If no images are visible, show all of them
      if (!anyShown && images.length > 0) {
        console.log("No images match the variant - showing all");
        images.forEach(img => {
          showMediaItem(img);
        });
      }
    }
    
    function showMediaItem(img) {
      // Get the parent media item container
      const mediaItem = findMediaItemParent(img);
      if (mediaItem) {
        mediaItem.style.display = '';
        
        // If this is the first visible media item, make it active
        if (mediaItem.classList.contains('product__media-item') && 
            !document.querySelector('.product__media-item.is-active:not([style*="display: none"])')) {
          document.querySelectorAll('.product__media-item.is-active').forEach(active => {
            active.classList.remove('is-active');
          });
          mediaItem.classList.add('is-active');
        }
      }
    }
    
    function hideMediaItem(img) {
      // Get the parent media item container
      const mediaItem = findMediaItemParent(img);
          // console.log(mediaItem)
      
      if (mediaItem) {
        mediaItem.style.display = 'none';
        
        // If this was the active item, remove the active class
        if (mediaItem.classList.contains('is-active')) {
          mediaItem.classList.remove('is-active');
        }
      }
    }
    
    function findMediaItemParent(img) {
      // Find the closest media item parent
      let parent = img.closest('.product__media-item');
      if (!parent) {
        parent = img.closest('.thumbnail-list__item');
      }
      if (!parent) {
        parent = img.closest('.product__thumbnail');
      }
      if(!parent){
        parent = img.closest('.media-wrapper');
      }
      if(!parent){
        parent = img.closest('.product__modal-opener')
      }
      // console.log(parent)
      return parent;
    }
  }
});